import { render, staticRenderFns } from "./minidetail.vue?vue&type=template&id=ac80bfd0&scoped=true&"
import script from "./minidetail.vue?vue&type=script&lang=js&"
export * from "./minidetail.vue?vue&type=script&lang=js&"
import style0 from "./minidetail.vue?vue&type=style&index=0&id=ac80bfd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac80bfd0",
  null
  
)

export default component.exports